(() => {
    const selectedSuburbs = document.querySelector<HTMLElement>("#selectedSuburbs");
    if (selectedSuburbs) {
        // remove
        selectedSuburbs.querySelectorAll<HTMLElement>('.typeahead-selected-item')
            .forEach(item => {
                const remove = item.querySelector(".typeahead-remove");
                remove?.addEventListener('click', () => {
                    item.remove();
                    disableInput();
                });
            });
    }

    // mock data
    let data = [
        { label: 'Bluewater Park, QLD', value: '4818', id: '5' },
        { label: 'Brisbane Market, QLD', value: '4106', id: '4' },
        { label: 'The Limits, QLD', value: '4625', id: '3' },
        { label: 'South Nanango, QLD', value: '4615', id: '2' },
        { label: 'Sydney, NSW', value: '2000', id: '1' },
    ]; // label and value are compulsory

    let typeaheadInput = document.querySelector("typeahead-input#typeaheadQuestionSuburbs");

    if (typeaheadInput) {
        typeaheadInput.doDataFetch = onDataFetch;
        typeaheadInput.addEventListener('select', onSelect);
        disableInput();
    }

    // This function will be triggered when user type in the input
    /**
    * @param {string} text  User input.
    * @param {func} callback Callback function must be called when suggested data is prepared.
    */
    function onDataFetch(text, callback) {
        text = text.toLowerCase();

        // make ajax call to fetch suggestions from server
        const suggestions = data;

        // callback
        callback(suggestions);
    }

    // This function will be triggered when user select a suggestion
    /**
    */
    function onSelect({ detail }) {
        if (detail) {
            const div = document.createElement('div');
            div.className = 'typeahead-selected-item';
            div.textContent = `${detail.label} (${detail.value})`;

            const remove = document.createElement('div');
            remove.className = 'typeahead-remove';
            remove.innerHTML = `
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" transform="translate(6 6)">
                        <line x1="12" y2="12"></line>
                        <line x2="12" y2="12"></line>
                        </g>
                        </svg>

                    </div>`;

            // id
            const input1 = document.createElement('input');
            input1.type = 'hidden';
            input1.name = 'Answer.Index';
            input1.value = detail.id;

            const input2 = document.createElement('input');
            input2.type = 'hidden';
            input2.name = `Answer[${detail.id}].Id`;
            input2.value = detail.id;

            const input3 = document.createElement('input');
            input3.type = 'hidden';
            input3.name = `Answer[${detail.id}].Name`;
            input3.value = detail.label;

            const input4 = document.createElement('input');
            input4.type = 'hidden';
            input4.name = `Answer[${detail.id}].Postcode`;
            input4.value = detail.value;

            div.appendChild(input1);
            div.appendChild(input2);
            div.appendChild(input3);
            div.appendChild(input4);
            div.appendChild(remove);
            selectedSuburbs?.appendChild(div);

            // remove
            remove.addEventListener('click', () => {
                div.remove();
                disableInput();
            });

            typeaheadInput?.dispatchEvent(new CustomEvent('clear'));

            disableInput();
        }
    }

    function disableInput() {
        const count = selectedSuburbs.querySelectorAll<HTMLElement>('.typeahead-selected-item').length;
        typeaheadInput?.dispatchEvent(new CustomEvent(count >= 3 ? 'disable' : 'enable'));
    }
})();
